import React, { useEffect, useRef, useState } from "react";

const SpiderManEffect = ({ toggle, setToggle }) => {
    const canvasRef = useRef(null);
    const [dotColor, setDotColor] = useState(localStorage.getItem('theme'));
    const dotsRef = useRef([]); // Use useRef to store dots

    useEffect(() => {
        // Listen for changes to localStorage
        const handleStorageChange = () => {
            setDotColor((prevDotColor) => prevDotColor === 'light' ? 'dark' : 'light'); // Use functional update
        };
        handleStorageChange();

        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext("2d");

        const resizeCanvas = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
            generateDots();
            drawDots();
        };

        const generateDots = () => {
            dotsRef.current = []; // Clear previous dots
            for (let index = 0; index < 70; index++) {
                dotsRef.current.push({
                    x: Math.floor(Math.random() * canvas.width),
                    y: Math.floor(Math.random() * canvas.height),
                    size: Math.random() * 3 + 5,
                    color: dotColor === 'dark' ? "#a1a1a1" : "#555555", // Use theme color here
                });
            }
        };

        const drawDots = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            dotsRef.current.forEach((dot) => {
                ctx.fillStyle = dot.color;
                ctx.beginPath();
                ctx.arc(dot.x, dot.y, dot.size, 0, Math.PI * 2);
                ctx.fill();
            });
        };

        const handleMouseMove = (event) => {
            const mouse = {
                x: event.clientX,
                y: event.clientY,
            };

            ctx.clearRect(0, 0, canvas.width, canvas.height);
            drawDots();

            dotsRef.current.forEach((dot) => {
                const distance = Math.sqrt(
                    (mouse.x - dot.x) ** 2 + (mouse.y - dot.y) ** 2
                );

                if (distance < 300) {
                    ctx.strokeStyle = dot.color;
                    ctx.lineWidth = 1;
                    ctx.beginPath();
                    ctx.moveTo(dot.x, dot.y);
                    ctx.lineTo(mouse.x, mouse.y);
                    ctx.stroke();
                }
            });
        };

        const handleMouseOut = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            drawDots();
        };

        window.addEventListener("mousemove", handleMouseMove);
        window.addEventListener("mouseout", handleMouseOut);
        window.addEventListener("resize", resizeCanvas);

        resizeCanvas();

        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseout", handleMouseOut);
            window.removeEventListener("resize", resizeCanvas); // Clean up the event listener
        };
    }, [toggle]); // Add dotColor to the dependency array

    useEffect(()=>{},[dotColor])

    return (
        <div className="hidden md:block absolute z-[-1] top-0 w-full h-screen bg-transparent overflow-hidden">
            <canvas
                ref={canvasRef}
                style={{
                    position: "absolute",
                    width: "100vw",
                    height: "100vh",
                    pointerEvents: "none", // Avoid blocking any interactions
                }}
            ></canvas>
        </div>
    );
};

export default SpiderManEffect;
